import axios from "axios";

async function uploadToS3(file, progress, error) {
  const matches = file.name.match(/\.([a-zA-Z0-9]+)$/);
  const fileExtension = matches ? matches[1] : "txt";

  return await axios.post(`/documents`, { contentType: file.type || "application/octet-stream", extension: fileExtension }).then((res) => {
    return axios
      .put(res.data.uploadURL, file, {
        headers: { "Content-Type": file.type },
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          progress(percentCompleted);
        },
      })
      .then(() => {
        progress(100);
        return {
          path: res.data.uploadURL,
          documentId: res.data.documentId,
        };
      })
      .catch(() => {
        error("There was an error uploading your file.");
      });
  });
}

export default function(instance) {
  instance.extend({
    uploader: uploadToS3,
  });
}
